<template>
  <div class="faq-accordion">
    <h2>{{ $t('chang-jian-wen-ti') }}</h2>
    <div class="faq-accordion__list">
      <Collapse
        v-for="faq in rightsDisplay?.faq || []"
        :key="faq.id"
        :model-value="activeId === faq.id"
        @update:modelValue="(val: boolean) => onToggle(faq.id, val)"
      >
        <template #title>
          {{ faq.question }}
        </template>
        <div class="rich-text" v-html="faq.answer"></div>
      </Collapse>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { useRightsStore } from '@rendora/common/store/rights';
import { Collapse } from '@rendora/design/components/collapse/index';
import { storeToRefs } from 'pinia';
import { ref, watch } from 'vue';

const rightsStore = useRightsStore();
const { rightsDisplay } = storeToRefs(rightsStore);

// 只允许展开一个（手风琴模式）
const activeId = ref<string | number | null>(null);

function onToggle(id: string | number, nextOpen: boolean) {
  activeId.value = nextOpen ? id : null;
}

watch(
  () => {
    return rightsDisplay.value?.faq;
  },
  newVal => {
    if (newVal) {
      activeId.value = newVal[0]?.id || null;
      console.debug(activeId.value, 43);
    }
  },
  {
    immediate: true,
  },
);
</script>

<style lang="scss">
.faq-accordion {
  margin: 0 auto;
  width: 100%;

  h2 {
    width: 100%;
    text-align: center;
    margin-top: 12px;
    font-size: 14px;
    font-weight: var(--x-weight-medium);
    color: var(--x-text-1);
    margin-bottom: 24px;
  }
}
</style>
